// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3Srrg","containerItemsCenter":"Skeleton_containerItemsCenter__3vb96"};